import { render, staticRenderFns } from "./list.vue?vue&type=template&id=bf5df52c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=bf5df52c&prod&lang=less&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=bf5df52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5df52c",
  null
  
)

export default component.exports